import React from 'react';
import ToDoItem from './ToDoItem';
import styled from 'styled-components';

const ToDoList = styled.div`
height: 400px;
padding: 5px;
width: 100%;
margin: 10px 0;
display: flex;
align-items: center;
flex-direction: column;
background-color: white;
overflow: auto;
flex-grow: 1;

`;
const toDoList = ( props ) => {
if(props.toDos.length === 0){
return (<div className="toDoList"><p>There are no todos.</p></div>);
}else{

}
return (
    <ToDoList className="toDoList">
{props.toDos.map((todo) => 
    <ToDoItem 
    id = {todo.id}
    key = {todo.id} 
    text = {todo.text} 
    completed = {todo.completed} 
    completedToggle = {props.completedToggle}
    deleteItem = {props.deleteItem}
    />)}
    </ToDoList>);
}
      

export default toDoList;